import { api as tasksViewActions } from './tasksViewActions';
import {
  actions as reportTaskProgressDialogActions,
  api as reportTaskProgressDialogApi,
  jsxActions as reportTaskProgressDialogJsxActions,
} from '../../../actions/Dialogs/ReportTaskProgressDialog/reportTaskProgressDialogActions';

export let api = {
  ...reportTaskProgressDialogApi,

  show(dispatch, getState) {
    return function (item = null) {
      dispatch(reportTaskProgressDialogActions.show(item));
    };
  },

  submit(dispatch, getState) {
    return function (taskData) {
      tasksViewActions.bulkProgressReport(dispatch, getState)(taskData);
      dispatch(reportTaskProgressDialogActions.hide());
    };
  },
};

export let jsxActions = {
  ...reportTaskProgressDialogJsxActions,

  submit(taskData) {
    return function (dispatch, getState) {
      return api.submit(dispatch, getState)(taskData);
    };
  },
};
